import React, { Component } from "react";
import PropTypes from "prop-types";
import YesNoModal from "../../../../../shared/components/modals/YesNoModal";

class PostScoreConfirmationModal extends Component {
  render() {
    const { isOpen, onAbort, onConfirm } = this.props;
    return (
      <YesNoModal
        onConfirm={onConfirm}
        onAbort={onAbort}
        isOpen={isOpen}
        yesTitle="Post Score"
        noTitle="Cancel"
      >
        <p>{this.props.validationMessage}</p>
      </YesNoModal>
    );
  }
}

PostScoreConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  validationMessage: PropTypes.string,
  onAbort: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default PostScoreConfirmationModal;
